<div class="status-banner" *ngIf="!isProduction" role="region" aria-label="Application status information">
    <span class="status-banner__item">
        <span class="status-banner__label">Env:</span> {{ environment }}
    </span>
    <span class="status-banner__sep">|</span>
    <span class="status-banner__item">
        <span class="status-banner__label">Notifications:</span> {{ deliveryMode }}
    </span>
    <span class="status-banner__sep">|</span>
    <span class="status-banner__item">
        <span class="status-banner__label">Build:</span> {{ version }} ({{ buildTimestamp }})
    </span>
    <span class="status-banner__sep">|</span>
    <span class="status-banner__item"
          [class.status-banner__simulated]="simulatedDate"
          [class.status-banner__clickable]="canEditClock"
          (click)="openClockDialog()">
        <span class="status-banner__label">{{ dateLabel }}</span> {{ dateValue }}
    </span>
</div>
